import React from 'react';

import appConfigs from '@nerdwallet/app-config';

import { WithURLRecord } from '../../components/url-record';
import type { UrlRecordOptions } from '../../components/url-record';
import getTaxonomy from '../../lib/page-taxonomy';

import RVBResults from './rvb-results';
import type { RVBResultsProps } from './rvb-results';

const URL_RECORD_OPTIONS: UrlRecordOptions = {
  url: () => `${appConfigs.SITE_BASE_URL}/mortgages/rent-vs-buy-calculator`,
  metadataOptions: () => {
    return {
      nerdLayoutMappings: { pageTaxonomy: getTaxonomy('rvb') },
      driverPageName: 'mortgages_rent_vs_buy_calculator',
    };
  },
};

const RVBResultsWrapper = (props: RVBResultsProps): JSX.Element => {
  return (
    <WithURLRecord
      {...props}
      options={URL_RECORD_OPTIONS}
      component={RVBResults}
    />
  );
};

export default RVBResultsWrapper;
